import { ITransaction, TransactionSource } from "../../../types";
import { ActionReason } from "../../../api/graphql/schema.generated";

/**
 * i18n key (namespace "ContactUserModal") of the label for a Contact user
 * reason. German and English live in src/v1/locales/{de,en}/ContactUserModal.json.
 */
export const actionReasonLabelKey = (reason: string) => `reasons.${reason}`;

const reason = (value: ActionReason) => ({
  value,
  labelKey: actionReasonLabelKey(value),
});

export const INCOMING_TRANSACTION_REASONS = [
  reason(ActionReason.SMALL_BUSINESS_MISSING),
  reason(ActionReason.WRONG_TAXRATE_ANCILLARY_SERVICE),
  reason(ActionReason.MISSING_TAX_EXEMPT_SALES),
  reason(ActionReason.NO_REDUCED_TAX),
  reason(ActionReason.REVERSE_CHARGE_MISSING),
  reason(ActionReason.OBLIGED_TAXES),
  reason(ActionReason.INCOMING_AMOUNT_WRONG),
  reason(ActionReason.VAT_ID_MISSING),
  reason(ActionReason.INVALID_VAT_ID),
  reason(ActionReason.SMALL_BUSINESS_VAT),
  reason(ActionReason.WRONG_OUTGOING_INVOICE),
  reason(ActionReason.INVOICE_REQUIRED),
  reason(ActionReason.ELECTRONIC_SERVICES),
];

export const OUTGOING_TRANSACTION_REASONS = [
  reason(ActionReason.INVALID_RECEIPT),
  reason(ActionReason.NO_HOSPITALITY_RECEIPT),
  reason(ActionReason.OUTGOING_AMOUNT_WRONG),
  reason(ActionReason.REVERSE_CHARGE_INFORMATION),
  reason(ActionReason.INVOICE_ABOVE_250),
  reason(ActionReason.INVOICE_BELOW_250),
  reason(ActionReason.UNCLEAR_EXPENSE),
  reason(ActionReason.EXTERNAL_BANK_ACCOUNT),
  reason(ActionReason.CAR_USAGE),
];

export const ALL_TRANSACTION_REASONS = [
  ...INCOMING_TRANSACTION_REASONS,
  ...OUTGOING_TRANSACTION_REASONS,
];

export const EMPTY_TRANSACTION: ITransaction = {
  email: "",
  firstName: "",
  lastName: "",
  id: "",
  type: "",
  amount: 0,
  valutaDate: "",
  name: "",
  iban: "",
  description: "",
  foreignCurrency: "",
  businessTypeComment: "",
  personalNote: null,
  assets: [],
  verified: false,
  source: TransactionSource.SOLARIS,
  currency: "EUR",
};
